import { Component } from "react";
import PropTypes from "prop-types";

import PaymentsRenderer from "./PaymentsRenderer";

import _ from "underscore";
import { numberWithSpaces } from "../../../../utilities/formaters";
import { getParts } from "./getParts";
import moment from "moment";
import backendAdminService from "../../../../services/backendAdminService/connector";
import { backendAdminConnect } from "../../../../reloansys.component/Reloansys.Bar";
import { BackendButton } from "../../../../auth/BackendButton";

class StatusRenderer extends Component {
  render() {
    let item = this.props.item;
    let repayments = {
      IntermediationFee: 0, //
      OtherFees: 0,
      KFMFee: 0,
      CollectionFee: 0,
      InvoiceFee: 0,
      PenaltyFee: 0, //
      ReminderFee: 0, //
      RescheduleFee: 0,
      RenewalFee: 0,
      LateFee: 0, //
      Interest: 0, //
      Principal: 0, //
    };

    let repaymenteKeys = Object.keys(repayments);
    let paymentKeys = item.Payments ? Object.keys(item.Payments) : [];

    let payments = paymentKeys.map((key) => {
      return item.Payments[key];
    });

    payments = _.sortBy(payments, (node) => {
      return -new Date(node.ReceiveDate).getTime();
    });

    for (var i = 0; i < paymentKeys.length; i++) {
      var paymentKey = paymentKeys[i];

      for (var j = 0; j < repaymenteKeys.length; j++) {
        var repaymenteKey = repaymenteKeys[j];

        if (item.Payments[paymentKey].Allocation[repaymenteKey]) {
          if (repayments[repaymenteKey] === 0)
            repayments[repaymenteKey] = { Amount: 0 };
          repayments[repaymenteKey].Amount +=
            item.Payments[paymentKey].Allocation[repaymenteKey].Amount;
        }
      }
    }

    let repaymntPartsTexts = [
      "Total Repayments: " + paymentKeys.length,
      "Total Amount: " + numberWithSpaces(item.Amount.Amount) + " kr",
    ];

    if (paymentKeys.length) repaymntPartsTexts.push("Parts:");

    getParts(repayments, repaymntPartsTexts);

    let stageTexts = [];
    let capitalDebt = item.CapitalDebt
      ? numberWithSpaces(item.CapitalDebt.Amount) + " kr"
      : "N/A";

    stageTexts.push(item.CreditStage);
    stageTexts.push("Remaining Capital Debt: " + capitalDebt);

    if (item.fullRepayment)
      stageTexts.push(
        "Full repayment: " +
          numberWithSpaces(item.fullRepayment.Amount.Amount) +
          " kr",
      );
    if (item.TerminationStatusChange && item.CreditStage === "Terminated")
      stageTexts.push(
        "Terminated: " +
          moment(item.TerminationStatusChange).format("YYYY-MM-DD"),
      );
    else if (
      item.TerminationStatusChange &&
      item.CreditStage === "TerminationNoticed"
    )
      stageTexts.push(
        "Termination Noticed: " +
          moment(item.TerminationStatusChange).format("YYYY-MM-DD"),
      );
    else stageTexts.push("Terminated: N/A");
    return (
      <div>
        <h4>Loan Status</h4>
        <BackendButton
          label={"View details"}
          url={`/loanstep/loans/${this.props.item.Id}`}
        />

        {/* TODO Remove <SimpleRenderer label={'Loan Stage:'} text={stageTexts} />
        <SimpleRenderer label={'Repayment Info:'} text={repaymntPartsTexts} /> */}

        {payments.map((payment, index) => {
          return (
            <PaymentsRenderer
              payment={payment}
              paymentKey="Allocation"
              dateKey="Date"
              key={index}
              isOpen={index < 3}
            />
          );
        })}
      </div>
    );
  }

  static propTypes = {
    item: PropTypes.object,
  };
}

export default backendAdminConnect(backendAdminService(StatusRenderer));
